import { styled } from '@material-ui/core/styles';

export const Container = styled('div')(() => ({
  width: '94%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '80vh',
}));
